import { render } from "./appointmentby-doc.vue?vue&type=template&id=135c87ab"
import script from "./appointmentby-doc.vue?vue&type=script&lang=js"
export * from "./appointmentby-doc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__